<div class="wrapper">
  <a (click)="logOut()" class="logOut">
    <mat-icon aria-hidden="false" aria-label="Example home icon" style="margin-top: 4px" fontIcon="exit_to_app">
    </mat-icon>
  </a>
</div>
